import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Loader from './Loader'
import { ORGANIZATIONS__INIT } from '../store/actions'

const OrganizationInitializer = ({ userId, children }) => {
    const [initialized, setInitialized] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        const fetch = async () => {
            await dispatch(ORGANIZATIONS__INIT(userId))
            setInitialized(true)
        }
        fetch()
    }, [userId])

    if (!initialized) return <Loader text="Data loading..." />

    return <>{children}</>
}

export default OrganizationInitializer
